export default "__VITE_ASSET__CcwIcf9l__"